import { render, staticRenderFns } from "./DefaultHeaderDropdownServer.vue?vue&type=template&id=32460312"
import script from "./DefaultHeaderDropdownServer.vue?vue&type=script&lang=js"
export * from "./DefaultHeaderDropdownServer.vue?vue&type=script&lang=js"
import style0 from "./DefaultHeaderDropdownServer.vue?vue&type=style&index=0&id=32460312&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports